<template>
  <div class="wrap" id="wrap">
    <Scrollama @step-enter="stepEnterHandler">
      <div class="step1" data-step="a">
        <div class="div-bg step1">
          <img :src="textData.img">
          <div class="big-data_p animation" v-show="show1">
            <div class="title">{{textData.title}}</div>
            <p class="fnt_24">{{textData.describe}}</p>
            <!--        <el-button>-->
            <!--          查看更多-->
            <!--        </el-button>-->
          </div>
        </div>
      </div>
      <div class="tab-wrap">
        <el-radio-group text-color="#0974fd" @input="radioChange" v-model="menuButton">
          <el-radio-button label="first">{{textData.tab1}} <div class="line"></div></el-radio-button>
          <el-radio-button label="second">{{textData.tab2}}<div class="line"></div></el-radio-button>
          <el-radio-button label="third">{{textData.tab3}}<div class="line"></div></el-radio-button>
          <el-radio-button label="fourth">{{textData.tab4}}</el-radio-button>
        </el-radio-group>

      </div>
      <div class="step2" data-step="b">
        <div class="product bg-img-maintain" id="first" v-show="show2">
          <div class="move-title animationToBottom animation" style="margin-top: 0">
            {{textData.tab1}}
          </div>
          <div class="move-content animation">
            <el-collapse v-model="activeName" @change="handlchange" accordion>
              <el-collapse-item v-for="(tab, tabIndex) in tab1List" :key="tabIndex"
                                :title="tab.tab" :name="tabIndex + 1"
                                @mouseover.native="overFn(tabIndex + 1)">
                <ul>
                  <li v-for="(item, index) in 4" :key="index">
                    <img src="../../../../static/images/graduateSchool/icon.png" alt="">
                    <div>{{tab['content' + item]}}</div>
                  </li>
                </ul>
              </el-collapse-item>
<!--              <el-collapse-item title="灵活使用，满足不同场景" name="2" @mouseover.native="overFn('2')">-->
<!--                <ul>-->
<!--                  <li v-for="(item,index) in productObj.flexibleList" :key="index"><img :src="item.src" alt="">-->
<!--                    <div>{{ item.title }}</div>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </el-collapse-item>-->
            </el-collapse>
            <div class="img-node" v-show="activeName==tabIndex+1" v-for="(tab, tabIndex) in tab1List" :key="tabIndex">
              <img :src="tab.img" alt="">
            </div>
<!--            <div class="img-node node-two" v-show="activeName==2">-->
<!--              <img src="../../../../static/images/graduateSchool/ls.png" alt="">-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="step3" data-step="c">
        <div class="advantage bg-img-maintain" id="second">
          <div class="title move-title first-level-title animation " v-show="show3">
            {{textData.tab2}}
          </div>
          <div class="content animation" v-show="show3">
            <div class="item bg-img-maintain" :class="'item'+(index+1)" v-for="(item,index) in advantageList"
                 :key="index">
              <div class="top">
                <div class="text">{{ item.tab }}</div>
                <div class="secondary-title">{{ item.describe }}</div>
              </div>
              <div class="bottom">
                <ul>
                  <li v-for="(item2,index2) in 3" :key="index2">
                    <img src="../../../../static/images/graduateSchool/2-1.png">
                    <div>{{ item['content'+ item2] }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" step4" data-step="d">
        <div class="scene bg-img-maintain" id="third">
          <div class="first-level-title animation move-title" v-show="show4">
            {{textData.tab3}}
          </div>
          <div class="tag animation" v-show="show4">
            <div :class="{'item':true,'secondary-title':true,'active':currentSlide==item.num}"
                 v-for="(item,index) in sceneTitleList" :key="index" @click="switchFn(item.num)">
              {{ item.tab }}
            </div>
          </div>
          <div class="imgnode animation" v-show="show4">
            <el-carousel v-model="currentSlide" ref="myCarousel" :drag="true" :show-arrow="false"
                         @change="onCarouselChange" :autoplay="false" indicator-position="none" :loop="false">
              <el-carousel-item v-for="(item, index) in sceneTitleList" :key="index">
                <div class="item">
                  <img style="width: 50%;height: 100%;" :src="item.img" ref="swif" @mousedown="switchImg($event)">
                  <div class="item-left" :style="{ backgroundImage: `url(${item.bg})`}" style="width:50%;">
                    <div class="title">{{ item.title }}</div>
                    <div class="txt">{{ item.describe }}</div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class=" step5" data-step="e">
        <div class="case " id="fourth">
          <div class=" move-title first-level-title animation first-level-title" v-show="show5">
            {{textData.tab4}}
          </div>
          <div class="content animation bg-img-maintain" :style="{ backgroundImage: `url(${caseList[0].img2})` }" v-show="show5">
            <el-carousel :drag="true" :show-arrow="false" :autoplay="false" indicator-position="none" :loop="false">
              <el-carousel-item v-for="(item,index) in caseList" :key="index">
                <div class="introduce">
                  <div class="div-img">
                    <img :src="item.img1" alt="">
                  </div>
                  <div class="div-font">
                    <div class="font-itema secondary-title">
                      {{item.tab}}
                    </div>
                    <div class="font-itemb text">
                      {{ item.describe }}
                    </div>
                    <div class="font-itemc">
                      <img src="../../../../static/images/graduateSchool/4-4.png" alt="">
                    </div>
                    <div class="font-itemd">
                      <div class="item" v-for="(item2,index2) in 4" :key="index2">
                        <div class="item-top">
                          <div class="num first-level-title">{{ item['count' + item2] }}</div>
                          <div class="unit text">{{  item['unit' + item2]  }}</div>
                        </div>
                        <div class="item-bottom text">
                          {{item['content' + item2]}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="step6" data-step="f">
        <footer-item></footer-item>
      </div>
    </Scrollama>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../components/footer-item'

export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      newsList: [],
      menuButton: '',
      offsetY: 0,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      currentSlide: 0,
      activeName: 1,
      // 产品功能
      productObj: {},
      // 核心优势
      advantageList: [],
      // 适用场景
      sceneTitleList: [],
      // 适用场景-图片
      sceneImgList: [],
      // 客户案例
      caseList: [],
      tab1List: [],
      textData: {}
    }
  },

  methods: {
    handlchange (val) {
      console.log(val)
    },
    overFn (val) {
      this.activeName = val
      this.copyactiveName = val
    },
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step1':
          this.show1 = true
          break
        case 'step2':
          this.show2 = true
          break
        case 'step3':
          this.show3 = true
          break
        case 'step4':
          this.show4 = true
          break
        case 'step5':
          this.show5 = true
          break
      }
    },
    radioChange (label) {
      console.log(label)
      let selector = '#' + label
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
      })
    },
    detailTo (item) {
    },
    onCarouselChange (index) {
      console.log(index)
      this.currentSlide = index
    },
    switchFn (val) {
      this.currentSlide = val
      this.$refs.myCarousel.setActiveItem(val)
      console.log(this.currentSlide)
    }
  },
  created () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page201.g201.filter(item => item.link === '数字化员工')[0]
      this.tab1List = this.$boss.page251.g251.reverse()
      this.advantageList = this.$boss.page261.g261.reverse()
      this.sceneTitleList = this.$boss.page271.g271.reverse().map((item, index) => {
        item.num = index
        item.bg = require('../../../../static/images/graduateSchool/3-2.png')
        return item
      })
      this.caseList = this.$boss.page281.g281.reverse()
    }
  },
  mounted: function () {
  }
}
</script>
<style scoped lang="less">
  @media screen and (max-width: 1500px) {
    //一级标题
    .first-level-title {
      font-size: 42px;
      font-weight: bold;
      color: #323232;
    }

    //二级标题
    .secondary-title {
      font-size: 24px;
      font-weight: bold;
      color: #323232;
    }

    //正文
    .text {
      font-size: 20px;
      color: #323232;
      margin-top: 70px;
    }

    //背景图宽度保持不变类
    .bg-img-maintain {
      background-size: cover !important;
      background-position: center !important;
    }

    .move-title {
      margin-top: 30px;
      position: relative;
      top: 50px;
      width: 100%;
      z-index: 999;
      font-size: 32px;
      color: #323232;
      font-weight: 500;
    }

    .move-content {
      margin-top: 150px;
      position: relative;
      width: 100%;
      height: 50vh;
      z-index: 999;
      display: flex;
      justify-content: space-between;
    }

    .wrap {
      width: 100%;
      height: 100%;
      /*overflow: auto;*/
    }

    .div-bg {
      width: 100%;
      height: 70vh;
      background: url("../../../../static/images/productAndService/bigData/bg.png") no-repeat;
      background-size: 100% 100%;
      img {
        width: 100%;
        height: 100%;
      }
      .big-data_p {
        position: relative;
        left: 100px;
        top: -60%;
        color: #fff;
        text-align: left;
        width: calc(100% - 100px);
        z-index: 999;
      }

      .big-data_p .title, .big-data_p p {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .big-data_p p {
        font-size: 24px;
      }

      .big-data_p .title {
        width: 100%;
        font-size: 42px;
        font-weight: 400;
        margin-bottom: 15px;
        line-height: 60px;
        max-height: 120px;
      }

      .big-data_p .el-button {
        margin-top: 10vh;
        width: 150px;
        color: #FFFFFF;
        background-color: transparent;
        border: 1px solid #FFFFFF;
        font-size: 16px;
      }
    }

    .tab-wrap {
      position: relative;
      top: -35px;
      width: 90%;
      height: 70px;
      margin-left: 5%;
      background-color: #FFFFFF;
      box-shadow: 0 0 8px 8px rgba(0, 18, 31, 0.07);

      .el-radio-group {
        width: 100%;
        height: 70px;

        .el-radio-button {
          width: 25%;
          height: 70px;

          /deep/ .el-radio-button__inner {
            width: 100%;
            height: 70px;
            line-height: 50px;
            font-size: 20px;
            box-shadow: -1px 0 0 0 transparent;
            background-color: transparent;
            color: #323232;
            border: 1px solid transparent;
          }
        }
      }

      /deep/ .line {
        width: 2px;
        height: 50px;
        border-left: 2px solid #f1f1f1;
        float: right;
      }
    }

    .product {
      /deep/ .el-collapse {
        width: 611px;
      }

      /deep/ .el-collapse-item__header {
        font-size: 24px;
        font-weight: 500;
        height: 126px;
        line-height: 126px;
      }

      /deep/ .el-collapse-item {
        // border-left: 6px solid #CBDBFD;
        border-left: 3px solid #2f6ef6;
        box-shadow: 14px 14px 5px #F8F9FA;
        margin-bottom: 40px;
        padding-left: 70px;
      }

      /deep/ .is-active {
        font-size: 24px;
        font-weight: 500;
        color: #2f6ef6;
        padding-left: 35px;
        // border-left: 3px solid #2f6ef6;
        box-shadow: 4px 4px 15px #F8F9FA;
      }

      /deep/ .el-collapse-item__wrap {
        // border-left: 3px solid #2f6ef6;

      }

      /deep/ .el-icon-arrow-right {
        display: none;
      }

      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid rgba(0, 0, 0, 0);
      height: 790px;
      padding: 0px 100px 100px 100px;

      .move-content {
        display: flex;

        .img-node {
          height: 577px;
          width: 975px;
          margin-left: 50px;

          img {
            width: 100%;
            height: 100%;
            /*position: relative;*/
            /*top: 45%;*/
            /*left: 25%;*/
          }
        }

        .node-one {
          background: url("../../../../static/images/graduateSchool/product-left-bg.png") no-repeat;
        }

        .node-two {
          background: url("../../../../static/images/graduateSchool/product-left-bg.png") no-repeat;
        }
      }

      .item {
        background: url("../../../../static/images/graduateSchool/xz.png") no-repeat;
      }

    }

    .advantage {
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid rgba(0, 0, 0, 0);
      // height: 550px;
      height:71vh;
      padding: 0 100px;
      background: url("../../../../static/images/graduateSchool/bg.png") no-repeat;

      .title {
        border: 1px solid rgba(0, 0, 0, 0);
      }

      .content {
        margin-top: 70px;
        // height: 440px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        .item :hover {
          transform: scale(1.05);
        }
        .item {
          // width: 448px;
          width:21vw;
          // height: 440px;
          padding: 14px 40px;
          text-align: left;
          box-sizing: border-box;
          border-radius: 20px;
          .top {

            .text {
              margin-top: 0;

              margin-bottom: 20px;
            }
          }

          .bottom {
            margin-top: 50px;

            ul {
              padding: 0;
              // margin-top: 70px;
              list-style-type: none;

              li {
                display: flex;
                margin-bottom: 28px;

                img {
                  width: 15px;
                  height: 20px;
                }

                div {
                  // font-size: 20px;
                  font-size:2.2vh;
                  font-weight: 500;
                  margin-left: 20px;
                  height: 20px;
                  line-height: 20px;
                }
              }
            }
          }
        }

        .item1 {
          background: url("../../../../static/images/graduateSchool/2-11.png") no-repeat;
        }

        .item2 {
          background: url("../../../../static/images/graduateSchool/2-12.png") no-repeat;
        }

        .item3 {
          background: url("../../../../static/images/graduateSchool/2-13.png") no-repeat;
        }

        .item4 {
          background: url("../../../../static/images/graduateSchool/2-14.png") no-repeat;
        }
      }
    }

    .scene {
      border: 1px solid rgba(0, 0, 0, 0);
      padding: 0 100px;
      // height: 1000px;
      height:120vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;

      .tag {
        display: flex;
        justify-content: space-between;
        margin-top: 70px;
        width: 100%;

        .item {
          // width: 407px;
          width:20vw;
          height: 128px;
          line-height: 128px;

          text-align: center;
          background: url("../../../../static/images/enterpriseRecruitment/cz-default.png") no-repeat;
        }

        .active {
          color: #fff;
          background: url("../../../../static/images/enterpriseRecruitment/cz-active.png") no-repeat;
        }
      }

      .imgnode {
        margin-top: 50px;
        height: 665px;
        width: 100%;
        /deep/ .el-carousel {
          height: 650px;

        }

        .item {
          display: flex;
          // .img{
          //   width: 50%;height: 100%;
          // }
          .item-left {
            width: 50%;
            padding: 50px;
            text-align: left;
            box-shadow: 14px 14px 5px #F8F9FA;
            border: 3px solid transparent;
            // background: url("../../../../static/images/graduateSchool/3-2.png") no-repeat;
            .title {
              font-size: 24px
            }

            .txt {
              font-size: 20px;
              margin-top: 30px;
              color: rgba(31, 31, 31, 0.8);
            }
          }
        }
      }
    }

    .case {
      border: 1px solid rgba(0, 0, 0, 0);
      padding: 0 100px;
      height: 1000px;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;

      .content {
        margin-top: 70px;
        height: 745px;
        width: 100%;
        background: url("../../../../static/images/graduateSchool/4-3.png") no-repeat;
        padding: 100px;
        box-sizing: border-box;

        .introduce {
          width: 100%;
          height: 100%;
          // opacity:0.8;
          background-color: rgba(255, 255, 255, 0.8);
          // background-color: #fff;
          border-radius: 10px;
          padding: 100px;
          box-sizing: border-box;
          display: flex;

          .div-img {
            width: 100px;
            height: 100px;
            // background-color: #fff;
            border-radius: 10px;

            img {
              width: 100px;
              height: 100px;
            }
          }

          .div-font {
            flex: 1;
            text-align: left;
            margin-left: 100px;
            // display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            .font-itema {
            }

            .font-itemb {
              margin-top: 30px;
              color: rgba(31, 31, 31, 0.8);
              width:72%;
            }

            .font-itemc {
              width: 100%;
              height: 2px;
              margin-top: 60px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .font-itemd {
              flex: 1;
              display: flex;
              margin-top: 60px;

              .item {
                margin-right: 40px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 12vw;
                .item-top {
                  display: flex;
                  align-items: end;

                  .num {
                    color: rgba(31, 31, 31, 0.8);
                  }

                  .unit {
                    margin-top: 0;
                    margin-left: 10px;
                  }
                }

                .item-bottom {
                  margin-top: 0;
                  color: rgba(31, 31, 31, 0.8);
                }

              }
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 1501px) {
    //一级标题
    .first-level-title {
      font-size: 42px;
      font-weight: bold;
      color: #323232;
    }

    //二级标题
    .secondary-title {
      font-size: 24px;
      font-weight: bold;
      color: #323232;
    }

    //正文
    .text {
      font-size: 20px;
      color: #323232;
      margin-top: 70px;
    }

    //背景图宽度保持不变类
    .bg-img-maintain {
      background-size: cover !important;
      background-position: center !important;
    }

    .move-title {
      /*margin-top: 30px;*/
      position: relative;
      top: 50px;
      width: 100%;
      z-index: 999;
      font-size: 32px;
      color: #323232;
      font-weight: 500;
    }

    .move-content {
      margin-top: 150px;
      position: relative;
      width: 100%;
      height: 50vh;
      z-index: 999;
      display: flex;
      justify-content: space-between;
    }

    .wrap {
      width: 100%;
      height: 100%;
      /*overflow: auto;*/
    }

    .div-bg {
      width: 100%;
      height: 70vh;
      background: url("../../../../static/images/productAndService/bigData/bg.png") no-repeat;
      background-size: 100% 100%;

      img {
        width: 100%;
        height: 100%;
      }
      .big-data_p {
        position: relative;
        left: 100px;
        top: -60%;
        color: #fff;
        text-align: left;
        width: calc(100% - 100px);
        z-index: 999;
      }

      .big-data_p .title, .big-data_p p {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .big-data_p p {
        font-size: 24px;
      }

      .big-data_p .title {
        width: 100%;
        font-size: 42px;
        font-weight: 400;
        margin-bottom: 15px;
        line-height: 60px;
        max-height: 120px;
      }

      .big-data_p .el-button {
        margin-top: 10vh;
        width: 150px;
        color: #FFFFFF;
        background-color: transparent;
        border: 1px solid #FFFFFF;
        font-size: 16px;
      }
    }

    .tab-wrap {
      position: relative;
      top: -35px;
      width: 90%;
      height: 70px;
      margin-left: 5%;
      background-color: #FFFFFF;
      box-shadow: 0 0 8px 8px rgba(0, 18, 31, 0.07);

      .el-radio-group {
        width: 100%;
        height: 70px;

        .el-radio-button {
          width: 25%;
          height: 70px;

          /deep/ .el-radio-button__inner {
            width: 100%;
            height: 70px;
            line-height: 50px;
            font-size: 20px;
            box-shadow: -1px 0 0 0 transparent;
            background-color: transparent;
            color: #323232;
            border: 1px solid transparent;
          }
        }
      }

      /deep/ .line {
        width: 2px;
        height: 50px;
        border-left: 2px solid #f1f1f1;
        float: right;
      }
    }

    .product {
      /deep/ .el-collapse {
        width: 611px;
      }

      /deep/ .el-collapse-item__header {
        font-size: 24px;
        font-weight: 500;
        height: 126px;
        line-height: 126px;
      }

      /deep/ .el-collapse-item {
        // border-left: 6px solid #CBDBFD;
        border-left: 3px solid #2f6ef6;
        box-shadow: 14px 14px 5px #F8F9FA;
        margin-bottom: 40px;
        padding-left: 70px;
      }

      /deep/ .is-active {
        font-size: 24px;
        font-weight: 500;
        color: #2f6ef6;
        padding-left: 35px;
        // border-left: 3px solid #2f6ef6;
        box-shadow: 4px 4px 15px #F8F9FA;
      }

      /deep/ .el-collapse-item__wrap {
        // border-left: 3px solid #2f6ef6;

      }

      /deep/ .el-icon-arrow-right {
        display: none;
      }

      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid rgba(0, 0, 0, 0);
      height: 790px;
      padding: 0px 100px 100px 100px;

      .move-content {
        display: flex;

        .img-node {
          height: 577px;
          width: 975px;
          margin-left: 50px;
          img {
            /*position: relative;*/
            /*left: 5%;*/
            width: 100%;
            height: 100%;
          }
        }

        .node-one {
          background: url("../../../../static/images/graduateSchool/product-left-bg.png") no-repeat;
        }

        .node-two {
          background: url("../../../../static/images/graduateSchool/product-left-bg.png") no-repeat;
        }
      }

      .item {
        background: url("../../../../static/images/graduateSchool/xz.png") no-repeat;
      }
    }

    .advantage {
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid rgba(0, 0, 0, 0);
      height: 550px;
      padding: 0 100px;
      background: url("../../../../static/images/graduateSchool/bg.png") no-repeat;

      .title {
        border: 1px solid rgba(0, 0, 0, 0);
      }

      .content {
        margin-top: 70px;
        // height: 440px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        .item :hover {
          transform: scale(1.05);
        }
        .item {
          // width: 448px;
          width:21vw;
          height: 440px;
          padding: 40px 60px;
          text-align: left;
          box-sizing: border-box;

          .top {

            .text {
              margin-top: 0;

              margin-bottom: 20px;
            }
          }

          .bottom {
            margin-top: 100px;

            ul {
              padding: 0;
              // margin-top: 70px;
              list-style-type: none;

              li {
                display: flex;
                margin-bottom: 40px;

                img {
                  width: 15px;
                  height: 20px;
                }

                div {
                  // font-size: 20px;
                  font-size:2.2vh;
                  font-weight: 500;
                  margin-left: 20px;
                  height: 20px;
                  line-height: 20px;
                }
              }
            }
          }
        }

        .item1 {
          background: url("../../../../static/images/graduateSchool/2-11.png") no-repeat;
        }

        .item2 {
          background: url("../../../../static/images/graduateSchool/2-12.png") no-repeat;
        }

        .item3 {
          background: url("../../../../static/images/graduateSchool/2-13.png") no-repeat;
        }

        .item4 {
          background: url("../../../../static/images/graduateSchool/2-14.png") no-repeat;
        }
      }
    }

    .scene {
      border: 1px solid rgba(0, 0, 0, 0);
      padding: 0 100px;
      // height: 1000px;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;

      .tag {
        display: flex;
        justify-content: space-between;
        margin-top: 70px;
        width: 100%;

        .item {
          // width: 407px;
          width:22vw;
          height: 128px;
          line-height: 128px;

          text-align: center;
          background: url("../../../../static/images/enterpriseRecruitment/cz-default.png") no-repeat;
        }
        .item:hover {
          transform: scale(1.05);
        }
        .active {
          color: #fff;
          background: url("../../../../static/images/enterpriseRecruitment/cz-active.png") no-repeat;
        }
      }

      .imgnode {
        margin-top: 50px;
        height: 665px;
        width: 100%;

        /deep/ .el-carousel {
          height: 650px;
        }

        .item {
          display: flex;

          .item-left {
            padding: 50px;
            text-align: left;
            box-shadow: 14px 14px 5px #F8F9FA;
            border: 3px solid transparent;
            // background: url("../../../../static/images/graduateSchool/3-2.png") no-repeat;
            .title {
              font-size: 24px
            }

            .txt {
              font-size: 20px;
              margin-top: 30px;
              color: rgba(31, 31, 31, 0.8);
            }
          }
        }

      }
    }

    .case {
      border: 1px solid rgba(0, 0, 0, 0);
      padding: 0 100px;
      height: 1000px;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;

      .content {
        margin-top: 70px;
        height: 745px;
        width: 100%;
        background: url("../../../../static/images/graduateSchool/4-3.png") no-repeat;
        padding: 100px;
        box-sizing: border-box;

        .introduce {
          width: 100%;
          height: 100%;
          // opacity:0.8;
          background-color: rgba(255, 255, 255, 0.8);
          // background-color: #fff;
          border-radius: 10px;
          padding: 100px;
          box-sizing: border-box;
          display: flex;

          .div-img {
            width: 100px;
            height: 100px;
            // background-color: #fff;
            border-radius: 10px;

            img {
              width: 100px;
              height: 100px;
            }
          }

          .div-font {
            flex: 1;
            text-align: left;
            margin-left: 100px;
            // display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            .font-itema {
            }

            .font-itemb {
              margin-top: 30px;
              color: rgba(31, 31, 31, 0.8);
              // width:72%;
            }

            .font-itemc {
              width: 100%;
              height: 2px;
              margin-top: 60px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .font-itemd {
              flex: 1;
              display: flex;
              margin-top: 60px;

              .item {
                margin-right: 40px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 12vw;
                .item-top {
                  display: flex;
                  align-items: end;

                  .num {
                    color: rgba(31, 31, 31, 0.8);
                  }

                  .unit {
                    margin-top: 0;
                    margin-left: 10px;
                  }
                }

                .item-bottom {
                  margin-top: 0;
                  color: rgba(31, 31, 31, 0.8);
                }

              }
            }
          }
        }
      }
    }
  }

  .footer-style {
    width: 100%;
    height: 500px;
  }

  /deep/ .el-carousel {
    width: 100%;
    height: 100%;

  }

  /deep/ .el-carousel__container {
    width: 100%;
    height: 100%;
  }

  /deep/ .el-collapse {
    border-bottom: 1px solid transparent !important;
    ul {
      list-style-type: none;

      li {
        display: flex;
        text-align: left;
        margin-bottom: 40px;

        div {
          margin-left: 20px;
          font-size: 20px;
          color: rgba(31, 31, 31, 0.8);
          height: 16px;
          line-height: 16px;
        }

        img {
          width: 15px;
          height: 16px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/productAndService/bigData/graduateSchool.vue